import { render, staticRenderFns } from "./_totalProductNearExpiries.vue?vue&type=template&id=9b3a5060&scoped=true&"
import script from "./_totalProductNearExpiries.vue?vue&type=script&lang=js&"
export * from "./_totalProductNearExpiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3a5060",
  null
  
)

export default component.exports